import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { terraProxyApiClient } from '../clients/testerClient';
import type { CredentialPreviewDto } from '@terra/shared-contracts-applications';

const EMPTY_ARRAY: CredentialPreviewDto[] = [];

export function useCredentialsPreview({
  applicationId,
}: {
  applicationId?: string;
}) {
  const query = useQuery({
    queryKey: ['credentials-preview', applicationId],
    queryFn: async (): Promise<CredentialPreviewDto[]> => {
      if (!applicationId) {
        return [];
      }

      const result =
        await terraProxyApiClient.getCredentialsPreview(applicationId);

      return result?.credentials || [];
    },
    enabled: !!applicationId,
    staleTime: 30000,
  });

  const credentialsPreview = useMemo(
    () => query.data ?? EMPTY_ARRAY,
    [query.data],
  );

  return {
    credentialsPreview,
    isLoading: query.isLoading,
    error: query.error,
  };
}
